export default class OrderController {
  constructor(OrdersDataProvider) {
    "ngInject"
    this.OrdersDataProvider = OrdersDataProvider;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = {10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All'};
    this.field = 'id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.getOrders();
    this.checkboxes = [];
    this.checkboxesStatus = [];
    let
      vm = this;
    vm.open1 = function () {
      vm.popup1.opened = true;
    };
    vm.open2 = function () {
      vm.popup2.opened = true;
    };
    vm.format = 'yyyy-MM-dd';
    vm.altInputFormats = ['M!/d!/yyyy'];
    vm.popup1 = {
      opened: false
    };
    vm.popup2 = {
      opened: false
    };

  }

  getSortRecors(field, order_type, col, colTopDown) {
    this.field = field;
    this.order_type = order_type;
    this.col = col;
    this.colTopDown = colTopDown;
    this.getOrders();
  }

  getOrders() {
    let currency = [];
    currency['default'] = 'kr';
    currency['signlabs.se'] = 'SEK';
    currency['signlabs.dk'] = 'DKK';
    currency['signlabs.no'] = 'NOK';
    currency['signlabs.fi'] = 'EUR';
    currency['signlabs.de'] = 'EUR';
    currency['signlabs.at'] = 'EUR';
    currency['signlabs.ch'] = 'EUR';
    currency['signlabs.es'] = 'EUR';
    currency['signlabs.fr'] = 'EUR';
    currency['signlabs.it'] = 'EUR';
    currency['signlabs.nl'] = 'EUR';
    currency['signlabs.be'] = 'EUR';
    currency['signlabs.pl'] = 'PLN';
    currency['signlabs.eu'] = 'EUR';
    currency['signlabs.co.uk'] = 'GBP';
    currency['signlabs.com'] = 'USD';
    currency['signlabs.loc'] = 'SEK';

    let currencyDivider = [];
    currencyDivider['default'] = ",";
    currencyDivider['signlabs.se'] = ",";
    currencyDivider['signlabs.dk'] = ",";
    currencyDivider['signlabs.no'] = ",";
    currencyDivider['signlabs.fi'] = ".";
    currencyDivider['signlabs.de'] = ".";
    currencyDivider['signlabs.at'] = ".";
    currencyDivider['signlabs.ch'] = ".";
    currencyDivider['signlabs.es'] = ".";
    currencyDivider['signlabs.fr'] = ".";
    currencyDivider['signlabs.it'] = ".";
    currencyDivider['signlabs.nl'] = ".";
    currencyDivider['signlabs.be'] = ".";
    currencyDivider['signlabs.pl'] = ".";
    currencyDivider['signlabs.eu'] = ".";
    currencyDivider['signlabs.co.uk'] = ".";
    currencyDivider['signlabs.com'] = ",";
    currencyDivider['signlabs.loc'] = ",";

    let
      vm = this;
    let data = {};
    let searchData = {};
    searchData.invoice_status = vm.invoice_status;
    searchData.price_to = vm.price_to;
    searchData.price_from = vm.price_from;
    searchData.quantity = vm.quantity;
    searchData.fullName = vm.fullName;
    searchData.to = vm.to;
    searchData.from = vm.from;
    searchData.orderId = vm.orderId;
    searchData.delivery_type = vm.delivery_type;
    if (vm.orderType == 'Svea')
      searchData.orderType = 'Invoice';
    if (vm.orderType == 'Card')
      searchData.orderType = 'Card';
    searchData.id = vm.id;
    data.searchData = searchData;
    data.currentPage = vm.currentPage;
    data.pageLimit = vm.pageLimit;
    data.field = vm.field;
    data.order_type = vm.order_type;
    vm.OrdersDataProvider.getOrders(data).then(function (result) {
      vm.orders = result.data;
      console.log('gg',vm.orders);
      for (let i = 0; i < vm.orders.length; i++) {
        let orderData = vm.orders[i];
        vm.orders[i].currency = currency['default'];
        if(vm.orders[i].site_domain){
          if(vm.orders[i].site_domain == "localhost:8000"){
            vm.orders[i].site_domain = "signlabs.se";
          }
          vm.orders[i].currency = currency[vm.orders[i].site_domain];
          vm.orders[i].currencyDivider = currencyDivider[vm.orders[i].site_domain]
        }else{
          vm.orders[i].currencyDivider = ",";
        }
        if(!vm.orders[i].currency_rate){
          vm.orders[i].currency_rate = 1;
        }

    //    vm.orders[i].formatPrice = ((orderData.amount * vm.orders[i].currency_rate).toFixed(2)).replace(".",vm.orders[i].currencyDivider)+" "+vm.orders[i].currency;
		vm.orders[i].formatPrice = ((orderData.amount).toFixed(2)).replace(".",vm.orders[i].currencyDivider)+" "+vm.orders[i].currency;
        vm.mydate = new Date(orderData.created_at);
        vm.currentDateInvoice = new Date();
        if(orderData.invoice_created_at != null){
          vm.invoiceCreateDate = new Date(orderData.invoice_created_at);
        }else{
          vm.invoiceCreateDate = new Date();
        }
        orderData.invoice_due_date = angular.copy(vm.invoiceCreateDate);
        vm.currentDateInvoice = angular.copy(vm.currentDateInvoice);
        vm.invoiceNewDate = orderData.invoice_due_date.setDate(orderData.invoice_due_date.getDate() + 20);
        vm.invoiceNewDate = new Date(vm.invoiceNewDate);
        vm.invoiceNewDate = Date.parse(vm.invoiceNewDate);
        vm.currentDateInvoice = Date.parse(vm.currentDateInvoice);       
        
        if(vm.invoiceNewDate < vm.currentDateInvoice && orderData.invoice_status < 6 && orderData.invoice_number != null ){
          orderData.invoice_due_date_status = 0;
        }else if(vm.invoiceNewDate > vm.currentDateInvoice && orderData.invoice_status >= 6 && orderData.invoice_number != null){
          orderData.invoice_due_date_status = 1;
        }else{
          orderData.invoice_due_date_status = 2;
        }
        if(orderData.orderType == "Invoice" && orderData.invoice_number != null){
          orderData.dateShowOrNot = 1;
        }else{
          orderData.dateShowOrNot = 0;
        }
        // console.log('orderData.invoice_due_date_status',orderData.invoice_due_date_status);
        // console.log('orderData.dateShowOrNot',orderData.dateShowOrNot);
        
        orderData.due_date = angular.copy(vm.mydate);
        if (!orderData.delivery_time)
          orderData.delivery_time = '3-5';
        vm.delivery_time = orderData.delivery_time.split("-");
        let
          numberOfDaysToAdd = vm.delivery_time[1];
        orderData.due_date.setDate(orderData.due_date.getDate() + parseInt(numberOfDaysToAdd));
        //remove sat sunday
        let currentDate = vm.mydate;
        let fromDate = angular.copy(vm.mydate);
        let toDate = angular.copy(orderData.due_date);
        for (var d = fromDate; d <= toDate; d.setDate(d.getDate() + 1)) {
          currentDate = new Date(d);
          if (currentDate.getDay() == 0 || currentDate.getDay() == 6) {
            orderData.due_date.setDate(orderData.due_date.getDate() + 1);
          }
        }
        if (orderData.due_date.getDay() == 0)
          orderData.due_date.setDate(orderData.due_date.getDate() + 1);
        if (orderData.due_date.getDay() == 6)
          orderData.due_date.setDate(orderData.due_date.getDate() + 2);
      }
      vm.ordersTotal = result.total;
      vm.selectall = false;
    });
  }

  priceFormat(amount){
    let vm = this;
    console.log('listing',vm);
    return ((amount * vm.currency_rate).toFixed(2)).replace(".",vm.currencyDivider)+" "+vm.currency;
  }

  changeStatus() {
    if (!this.invoice_status_change) {
      return false;
    }
    if (this.checkboxes.length == 0) {
      alert('please select order first');
      return false;
    }
    let
      vm = this;
    let
      data = {'invoice_status': vm.invoice_status_change, 'ids': vm.checkboxes, 'status': vm.checkboxesStatus}
    vm.OrdersDataProvider.updateOrderStatus(data).then(function (resp) {
      vm.pages = resp;
      vm.getOrders();
      vm.checkboxes = [];
      vm.checkboxesStatus = [];
    })
  }

  removeOrder(id) {
    if (confirm("Are you sure to delete!") !== true) {
      return false;
    }
    let vm = this;
    vm.OrdersDataProvider.removeOrder(id).then(function (res) {
      vm.getOrders();
    })
  }

  clearFilter() {
    this.invoice_status = '';
    this.price_to = '';
    this.price_from = '';
    this.quantity = '';
    this.fullName = '';
    this.to = '';
    this.from = '';
    this.sveaOrderId = '';
    this.orderType = '';
    this.checkout_id = '';
    this.getOrders();
  }

  checkbox(order_id, status, checkbox) {
    if (checkbox == true) {
      if (this.checkboxes.indexOf(order_id) == '-1') {
        this.checkboxes.push(order_id);
        this.checkboxesStatus.push(status);
      }
    }
    else {
      let
        index = this.checkboxes.indexOf(order_id);
      this.checkboxes.splice(index, 1);
      this.checkboxesStatus.splice(index, 1);
    }
  }

  checkAll() {
    if (this.selectall) {
      let vm = this;
      angular.forEach(this.orders, function (order) {
        order.checked = 1;
        vm.checkboxes.push(order.order_id);
        vm.checkboxesStatus.push(order.invoice_status);
      });
    }
    else {
      angular.forEach(this.orders, function (order) {
        order.checked = 0;
      });
      this.checkboxes = [];
      vm.checkboxesStatus = []
    }
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/orders/components/listing/controller.js
 **/